import { render, staticRenderFns } from "./shipment-table.vue?vue&type=template&id=2cdcc778&scoped=true"
import script from "./shipment-table.vue?vue&type=script&lang=js"
export * from "./shipment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdcc778",
  null
  
)

export default component.exports